import { useAppDispatch, useAppSelector } from '@unistocks/shared/hooks/redux-hooks';
import { useSettingValue } from '@unistocks/shared/hooks/use-setting-value';
import { UnistocksSettings } from '@unistocks/shared/settings';
import { AppActions, selectActiveColorScheme } from '@unistocks/shared/store/root.slice';
import { ColorSchemeName, useColorScheme } from 'react-native';

interface ActiveColorSchemeHook {
  activeColorScheme: ColorSchemeName;
  /**
   * Set color scheme. If name is not provided, it will be set to the preferred color scheme of the device.
   */
  setActiveColorScheme: (name?: ColorSchemeName) => void;
  toggleDarkMode: () => void;
}

export const useActiveColorScheme = (): ActiveColorSchemeHook => {
  const dispatch = useAppDispatch();
  const deviceColorScheme = useColorScheme();
  const localColorScheme = useAppSelector(selectActiveColorScheme);
  const themeSetting = useSettingValue(UnistocksSettings.PreferredTheme) as ColorSchemeName;
  const activeColorScheme = localColorScheme || themeSetting || deviceColorScheme;

  const toggleDarkMode = () => {
    dispatch(AppActions.setTheme(activeColorScheme === 'dark' ? 'light' : 'dark'));
  };

  const setActiveColorScheme = (name?: ColorSchemeName) => {
    dispatch(AppActions.setTheme(name));
  };

  return {
    activeColorScheme,
    setActiveColorScheme: setActiveColorScheme,
    toggleDarkMode: toggleDarkMode
  };
};

export const useIsDarkMode = () => useActiveColorScheme().activeColorScheme === 'dark';
